import { FileTextFilled, QuestionCircleOutlined, DownloadOutlined } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import PropTypes from "prop-types";
import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useFormatter from "../../hooks/useFormatter";
import styles from "./_styles.less";
import axios from "axios";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";

export default function TextAnexo({ label, name, tooltip, value }) {
  const { t } = useTranslation();
  const { formatBytes } = useFormatter();
  const [text, setText] = useState("");

  const downloadDisabled = useMemo(() => !value, [value]);

  const handleViewAsText = useCallback(
    (e) => {
      e.preventDefault();
      unwrapAxiosPromise(
        axios.get(value?.url + "&output=text", { baseURL: "/" })
      ).then((data) => setText(data));
    },
    [value]
  );

  const visualizarArquivo = () => {
    if (!value?.url) return;
    const urlCompleta = value.url.startsWith("http") ? value.url : `${window.location.origin}${value.url}`;
    const googleViewerUrl = `https://docs.google.com/gview?url=${urlCompleta}`;
    window.open(googleViewerUrl, `viewer_${Date.now()}`, "width=1200,height=800,noopener,noreferrer");
  };

  const valueFmt = value ? (name ?? value.name) + " (" + formatBytes(value.size) + ")" : null;

  return (
    <div className={styles["text-anexo"]}>
      <label>
        {t(label)}
        {tooltip && (
          <Tooltip title={tooltip}>
            <QuestionCircleOutlined className={styles["icon"]} />
          </Tooltip>
        )}

        <p className={styles["value"]} title={valueFmt}>
          {downloadDisabled && valueFmt}
          {!downloadDisabled && (
            <>
              <a
                onClick={visualizarArquivo}
                style={{
                  flexShrink: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                }}
              >
                {valueFmt}
              </a>
              <a href="#" onClick={handleViewAsText}>
                <FileTextFilled style={{ fontSize: 15 }} />
              </a>
              <a href={value?.url} download={name ?? value?.name}>
                <DownloadOutlined style={{ fontSize: 15 }} />
              </a>
            </>
          )}
        </p>
      </label>

      <Modal
        className="ws-pre-line"
        title={name ?? value?.name}
        footer={false}
        open={text?.length > 0}
        width={640}
        onCancel={() => setText("")}
      >
        {text}
      </Modal>
    </div>
  );
}

TextAnexo.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.object,
};
